module.exports = __webpack_public_path__ + "static/media/arrows-alt-v.e9bda4f7.svg";